import * as THREE from 'three';

// Phase 4C preview seam. It does not create a camera/controller. It temporarily
// yields the Property Room host so Kimi's existing FOCUS controller can frame a
// semantic exterior support, then restores the same guest without touching the
// WORLD->ROOM exact-return context.

let previewing = null;
let backButton = null;

function supportObject(slotId) {
  return window.__qa?.scene?.getObjectByName?.(`cbw:media:${slotId}`) || null;
}

function supportPose(object) {
  const center = new THREE.Vector3();
  object.getWorldPosition(center);
  center.y += 1.45;
  const forward = new THREE.Vector3(0, 0, 1).applyQuaternion(object.getWorldQuaternion(new THREE.Quaternion())).normalize();
  const side = new THREE.Vector3(1, 0, 0).applyQuaternion(object.getWorldQuaternion(new THREE.Quaternion())).normalize();
  const position = center.clone().addScaledVector(forward, 5.8).addScaledVector(side, 1.2);
  position.y += 1.25;
  return { position: position.toArray(), target: center.toArray(), fov: 38 };
}

function ensureBackButton() {
  if (backButton) return backButton;
  backButton = document.createElement('button');
  backButton.type = 'button';
  backButton.textContent = '← Volver al Studio';
  backButton.style.cssText = 'position:fixed;z-index:3000;right:22px;top:22px;border:1px solid rgba(255,255,255,.5);border-radius:999px;padding:11px 16px;background:rgba(24,49,42,.92);color:white;font:700 11px/1 system-ui;letter-spacing:.08em;text-transform:uppercase;backdrop-filter:blur(12px);cursor:pointer';
  backButton.onclick = () => closePreview();
  document.body.appendChild(backButton);
  return backButton;
}

function openPreview(slotId) {
  const qa = window.__qa;
  const bridge = window.__CBW_SURGERY?.bridge;
  const object = supportObject(slotId);
  if (!qa || !bridge || !object || !bridge.active || bridge.mode !== 'STUDIO') return false;

  const focusController = qa.authority?._controllers?.get?.('FOCUS');
  if (!focusController?.setPose) return false;

  const pose = supportPose(object);
  focusController.setPose(pose);
  qa.authority.request('FOCUS', { reason: `world-media-preview:${slotId}`, durationMs: 500, endPose: pose });

  previewing = slotId;
  bridge.active = false; // renderer may draw again; returnContext remains untouched.
  bridge.host.style.visibility = 'hidden';
  bridge.host.style.pointerEvents = 'none';
  document.querySelector('#world')?.removeAttribute('aria-hidden');
  ensureBackButton().hidden = false;
  document.documentElement.dataset.cbwMediaPreview = slotId;
  return true;
}

function closePreview() {
  const bridge = window.__CBW_SURGERY?.bridge;
  if (!bridge || !previewing) return false;
  bridge.active = true;
  bridge.host.style.removeProperty('visibility');
  bridge.host.style.removeProperty('pointer-events');
  document.querySelector('#world')?.setAttribute('aria-hidden', 'true');
  if (backButton) backButton.hidden = true;
  previewing = null;
  delete document.documentElement.dataset.cbwMediaPreview;
  return true;
}

const install = () => {
  if (!window.__CBW_MEDIA || !window.__CBW_SURGERY || !window.__qa) return requestAnimationFrame(install);
  window.__CBW_MEDIA.preview = openPreview;
  window.__CBW_MEDIA.closePreview = closePreview;
  window.__CBW_MEDIA.previewing = () => previewing;
};
install();
